export default __webpack_public_path__ + "static/media/czlowiek1.83d28a14.svg";